const setPB = (r, PB, limits) => {
  const {
    performanceBond,
    initialBuyingPower,
    maximumDailyLoss,
    approvedOvernightBuyingPower,
  } = limits;

  const clampedPB = Math.max(performanceBond.min, Math.min(performanceBond.max, PB));

  const buyingPowerMultiplier = Math.round((initialBuyingPower.max - initialBuyingPower.min) / (performanceBond.max - performanceBond.min));
  const dailyLossMultiplier = Math.round((maximumDailyLoss.max - maximumDailyLoss.min) / (performanceBond.max - performanceBond.min) * 10) / 10;
  const overnightMultiplier = Math.round((approvedOvernightBuyingPower.max - approvedOvernightBuyingPower.min) / (performanceBond.max - performanceBond.min));

  r.PB = clampedPB;
  r.IBP = clampedPB * buyingPowerMultiplier;
  r.MDL = clampedPB * dailyLossMultiplier;
  r.OBP = clampedPB * overnightMultiplier;

  r.IBP = Math.min(r.IBP, initialBuyingPower.max);
  r.MDL = Math.min(r.MDL, maximumDailyLoss.max);
  r.OBP = Math.min(r.OBP, approvedOvernightBuyingPower.max);
};

const setIBP = (r, IBP, limits) => {
  const {
    performanceBond,
    initialBuyingPower,
    maximumDailyLoss,
    approvedOvernightBuyingPower,
  } = limits;

  const clampedIBP = Math.max(initialBuyingPower.min, Math.min(initialBuyingPower.max, IBP));

  const buyingPowerMultiplier = Math.round((initialBuyingPower.max - initialBuyingPower.min) / (performanceBond.max - performanceBond.min));
  const dailyLossMultiplier = Math.round((maximumDailyLoss.max - maximumDailyLoss.min) / (performanceBond.max - performanceBond.min) * 10) / 10;
  const overnightMultiplier = Math.round((approvedOvernightBuyingPower.max - approvedOvernightBuyingPower.min) / (performanceBond.max - performanceBond.min));

  const calculatedPB = clampedIBP / buyingPowerMultiplier;

  r.IBP = clampedIBP;
  r.PB = calculatedPB;
  r.MDL = calculatedPB * dailyLossMultiplier;
  r.OBP = calculatedPB * overnightMultiplier;
  
  r.PB = Math.min(r.PB, performanceBond.max);
  r.MDL = Math.min(r.MDL, maximumDailyLoss.max);
  r.OBP = Math.min(r.OBP, approvedOvernightBuyingPower.max);
};

const setMDL = (r, MDL, limits) => {
  const {
    performanceBond,
    initialBuyingPower,
    maximumDailyLoss,
    approvedOvernightBuyingPower,
  } = limits;

  const clampedMDL = Math.max(maximumDailyLoss.min, Math.min(maximumDailyLoss.max, MDL));

  const buyingPowerMultiplier = Math.round((initialBuyingPower.max - initialBuyingPower.min) / (performanceBond.max - performanceBond.min));
  const dailyLossMultiplier = Math.round((maximumDailyLoss.max - maximumDailyLoss.min) / (performanceBond.max - performanceBond.min) * 10) / 10;
  const overnightMultiplier = Math.round((approvedOvernightBuyingPower.max - approvedOvernightBuyingPower.min) / (performanceBond.max - performanceBond.min));

  const calculatedPB = clampedMDL / dailyLossMultiplier;
  
  r.MDL = clampedMDL;
  r.PB = calculatedPB;
  r.IBP = calculatedPB * buyingPowerMultiplier;
  r.OBP = calculatedPB * overnightMultiplier;
  
  r.PB = Math.min(r.PB, performanceBond.max);
  r.IBP = Math.min(r.IBP, initialBuyingPower.max);
  r.OBP = Math.min(r.OBP, approvedOvernightBuyingPower.max);
};

const setOBP = (r, OBP, limits) => {
  const {
    performanceBond,
    initialBuyingPower,
    maximumDailyLoss,
    approvedOvernightBuyingPower,
  } = limits;

  const clampedOBP = Math.max(approvedOvernightBuyingPower.min, Math.min(approvedOvernightBuyingPower.max, OBP));

  const buyingPowerMultiplier = Math.round((initialBuyingPower.max - initialBuyingPower.min) / (performanceBond.max - performanceBond.min));
  const dailyLossMultiplier = Math.round((maximumDailyLoss.max - maximumDailyLoss.min) / (performanceBond.max - performanceBond.min) * 10) / 10;
  const overnightMultiplier = Math.round((approvedOvernightBuyingPower.max - approvedOvernightBuyingPower.min) / (performanceBond.max - performanceBond.min));

  const calculatedPB = clampedOBP / overnightMultiplier;

  r.OBP = clampedOBP;
  r.PB = calculatedPB;
  r.IBP = calculatedPB * buyingPowerMultiplier;
  r.MDL = calculatedPB * dailyLossMultiplier;
  
  r.PB = Math.min(r.PB, performanceBond.max);
  r.IBP = Math.min(r.IBP, initialBuyingPower.max);
  r.MDL = Math.min(r.MDL, maximumDailyLoss.max);
};

const setOvernight = (r, PB, limits) => {
  const { performanceBond, approvedOvernightBuyingPower } = limits;
  
  const clampedPB = Math.max(performanceBond.min, Math.min(performanceBond.max, PB));
  
  const overnightMultiplier = Math.round((approvedOvernightBuyingPower.max - approvedOvernightBuyingPower.min) / (performanceBond.max - performanceBond.min));
  
  r.OBP = clampedPB * overnightMultiplier;
  r.OBP = Math.min(r.OBP, approvedOvernightBuyingPower.max);
};

const RateCalculator = { setIBP, setMDL, setOBP, setPB, setOvernight };

export default RateCalculator;
